export default __webpack_public_path__ + "static/background-3-390f2655812df117e4c9fe0762e16338.png";